import { render, staticRenderFns } from "./ChangeTimetableRequests.vue?vue&type=template&id=4a91657d"
import script from "./ChangeTimetableRequests.vue?vue&type=script&lang=js"
export * from "./ChangeTimetableRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports